import { z } from 'zod';

import { BaseModelSchema, OptionalTimestampSchema, TimestampSchema } from './common.js';

// Workspace Schemas
export const WorkspaceCreateSchema = z
    .object({
        name: z.string().min(1, 'Workspace name is required'),
        isPersonal: z.boolean().optional().default(false),
    })
    .strict();

export type WorkspaceCreate = z.infer<typeof WorkspaceCreateSchema>;

export const WorkspaceSchema = BaseModelSchema.extend({
    name: z.string().min(1, 'Workspace name is required'),
    description: z.string().optional(),
    isPersonal: z.boolean().optional(),
    createdBy: z.string().uuid(),
    settings: z.object({
        visibleSystemCategories: z.array(z.string()).optional(),
    }).optional(),
});

export type Workspace = z.infer<typeof WorkspaceSchema>;

export const WorkspaceUpdateSchema = z.object({
    name: z.string().min(1, 'Workspace name is required').optional(),
    description: z.string().optional(),
    isPersonal: z.boolean().optional(),
    settings: z.object({
        visibleSystemCategories: z.array(z.string()).optional(),
    }).optional(),
});

export type WorkspaceUpdate = z.infer<typeof WorkspaceUpdateSchema>;

// Workspace Member Schemas
export const WorkspaceMemberSchema = z.object({
    id: z.string().uuid(),
    workspaceId: z.string().uuid(),
    userId: z.string().uuid(),
    role: z.enum(['owner', 'admin', 'member']),
    status: z.enum(['pending', 'active', 'inactive']),
    joinedAt: TimestampSchema,
    invitedBy: z.string().uuid().optional(),
});

export type WorkspaceMember = z.infer<typeof WorkspaceMemberSchema>;

export const WorkspaceMemberCreateSchema = z.object({
    workspaceId: z.string().uuid(),
    userId: z.string().uuid(),
    role: z.enum(['owner', 'admin', 'member']).default('member'),
    status: z.enum(['pending', 'active', 'inactive']).default('pending'),
    invitedBy: z.string().uuid().optional(),
});

export type WorkspaceMemberCreate = z.infer<typeof WorkspaceMemberCreateSchema>;

// Workspace Invite Schemas
export const WorkspaceInviteSchema = z.object({
    id: z.string().uuid(),
    workspaceId: z.string().uuid(),
    email: z.string().email(),
    token: z.string(),
    role: z.enum(['owner', 'admin', 'member']),
    status: z.enum(['pending', 'accepted', 'expired', 'revoked']),
    createdBy: z.string().uuid(),
    usedBy: z.string().uuid().optional(),
    expiresAt: TimestampSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});

export type WorkspaceInvite = z.infer<typeof WorkspaceInviteSchema>;

export const WorkspaceInviteCreateSchema = z.object({
    workspaceId: z.string().uuid(),
    email: z.string().email(),
    role: z.enum(['owner', 'admin', 'member']).default('member'),
    expiresAt: OptionalTimestampSchema,
});

export type WorkspaceInviteCreate = z.infer<typeof WorkspaceInviteCreateSchema>;


